import { useQuery } from '@tanstack/react-query';

import { HuellApi } from '../api';

export const QUERY_KEY_PERSONALIZATION = 'huell-personalization';
export const usePersonalization = () => {
  return useQuery([QUERY_KEY_PERSONALIZATION], HuellApi.fetchPersonalization);
};
